"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function OurStory() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const portraitRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (portraitRef.current) {
        const rect = portraitRef.current.getBoundingClientRect();
        const centerY = window.innerHeight / 2;
        const elementCenterY = rect.top + rect.height / 2;
        const distance = centerY - elementCenterY;
        setScrollY(distance * 0.05);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={sectionRef} className="relative bg-background py-16 sm:py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: "linear-gradient(hsl(0, 0%, 0%) 1px, transparent 1px), linear-gradient(90deg, hsl(0, 0%, 0%) 1px, transparent 1px)",
      backgroundSize: "32px 32px"
    }} />

      <div className="container mx-auto px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={portraitRef} className={`relative overflow-hidden rounded-lg shadow-soft transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
          transform: `translateY(${scrollY}px)`,
          transition: "transform 0.1s linear"
        }}>
            <div className="group relative aspect-[3/4] overflow-hidden rounded-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/freedom_productions_founders_portrait.png" alt="Freedom Productions Founders" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" />
            </div>
          </div>

          {}
          <div className={`flex flex-col justify-center space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Our Story
            </h2>
            <div className="space-y-4 text-foreground/80 text-lg leading-relaxed">
              <p>
                Freedom Productions, LLC was founded on the belief that clarity, 
                structure, and strategic support are the keys to unlocking growth—whether 
                you're building a business or bringing a creative vision to life.
              </p>
              <p>
                We started by helping small businesses streamline their operations and 
                remove the burden of day-to-day administrative tasks. Over time, we 
                discovered a parallel need in the creative industry: filmmakers and 
                producers struggling to organize their projects and secure funding.
              </p>
              <p>
                Today, Freedom Productions serves as both an operational partner and a 
                project accelerator. We combine hands-on management with film development 
                expertise, delivering the systems, relationships, and momentum our clients 
                need to succeed.
              </p>
              <p className="font-semibold text-foreground">
                Our mission is simple: to help you focus on execution while we handle the 
                structure, so you can achieve measurable, meaningful results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}